import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyEivPayerDeltaIcon = lazy(() => import('./svg-components/eiv-payer-delta-icon'));

const EivPayerDeltaIcon = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyEivPayerDeltaIcon {...rest} />
  </Suspense>
);

export default EivPayerDeltaIcon;
